import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionPersistence } from '../../hooks/useSessionPersistence';

const Frame224: React.FC = () => {
  const navigate = useNavigate();
  const { completeTask } = useSessionPersistence();

  const handleReturnToDashboard = async () => {
    // Mark funeral task as complete
    await completeTask('funeral');
    navigate('/frame-140');
  };

  return (
    <div className="min-h-screen bg-stone-50 flex flex-col items-center justify-center">
      <h1 className="text-2xl font-semibold text-stone-800 mb-4">Summary Page</h1>
      <p className="text-stone-600 mb-6">This page is under construction.</p>
      <button
        onClick={handleReturnToDashboard}
        className="px-4 py-2 bg-cyan-700 text-white rounded-md hover:bg-cyan-800"
      >
        Return to Dashboard
      </button>
    </div>
  );
};

export default Frame224;